<template>
	<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
					{{$t('3268')}}
				</div>
				<div class="mgr-24 right-button">
					<div
							class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle">
							<button class="material-icons mdc-icon-button t-color-iconActive t-headline6 js--dropdown-toggle">more_horiz</button>
							<div class="mdc-menu mdc-menu-surface toggle-menu" id="addedMenu">
								<ul class="mdc-list mgl-2 mgr-2" role="menu" aria-hidden="true" aria-orientation="vertical"
									>
									<li class="mdc-list-item" role="menuitem" @click="modifyStore()" @keypress="modifyStore()" tabindex="0">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body6 font-r">{{$t('3279')}}</span>
									</li>
									<li class="mdc-list-item" role="menuitem"  @click="deleteProduct()" @keypress="deleteProduct()" tabindex="0">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body6 font-r">{{$t('3280')}}</span>
									</li>
								</ul>
							</div>
						</div>
				</div>                                                                                  
			</div>
			<div class="divider"></div>
		   
			<div class="container container--narrow">
				<div class="pdt-50 pdb-28">
					<div class="d-flex">
						<div class="edm-upload pdr-40" v-if="details && details.image && details.image.resourceUri">
							<img :src="details.image.resourceUri" :alt="details.image.name" class="b-radius4">
						</div>
						<div class="edm-upload pdr-40" v-else>
							<img src="/img/image_noimage.png" alt="" class="b-radius4">
						</div>
						<div class="flex-grow-1">
							<div class="t-body3 t-line-h-22 t-color-bodyGrayA  font-r" v-if="details">{{details && details.goods? details.goods.hcategoryNames:''}}</div>
							<div class="t-headline13 l-spacing66 t-line-h-34 mgt-1 font-m" v-if="details">{{details && details.goods? details.goods.name:''}}</div>
							<div class="t-body6 t-color-bodyGrayB t-line-h-20 mgt-16 l-spacing105 font-r">{{details && details.goods? details.goods.barcode:''}}</div>
							<div class="t-body1 t-color-bodyGrayA l-spacing48 t-line-h-22 font-r mgt-16">{{details && details.goods? details.goods.description:''}}</div>
						</div>
					</div>
				</div>
				
			</div>
			<div class="divider"></div>
			<div class="bg-documentGray">
				<div class="container container--narrow pdt-28 pdb-22">
					
						<div class="mdc-card mgb-28">
							<div class="pda-24 t-headline7 t-line-h-22 l-spacing6 font-m">	{{$t('3269')}}</div>
							<div class="divider"></div>
							<div class="pdt-8 pdb-8 pdl-24 pdr-24">
								<div class="pdt-8 pdb-8" v-if="details && details.receivingDate">
									<div class="t-body3 t-color-bodyGrayA t-line-h-20 l-spacing42 font-r" >	{{$t('3270')}}</div>
									<div class="mgt-4 t-body1 font-r t-line-h-24">{{$moment(details.receivingDate).format('L')}}</div>
								</div>
								<div class="pdt-8 pdb-8" v-if="details && details.expirationDate">
									<div class="t-body3 t-color-bodyGrayA t-line-h-20 l-spacing42 font-r">{{$t('3271')}}</div>
									<div class="mgt-4 t-body1 font-r t-line-h-24">	{{$moment(details.expirationDate).format('L')}}</div>
								</div>
								<div class="pdt-8 pdb-8" v-if="details && details.stock">
									<div class="t-body3 t-color-bodyGrayA t-line-h-20 l-spacing42 font-r">{{$t('3272')}}</div>
									<div class="mgt-4 t-body1 font-r t-line-h-24">{{details.stock}}</div>
								</div>
							</div>
						</div>

						<div class="mdc-card mgb-28" v-if="checkedList && checkedList.length>0">
							<div class="pda-24 t-headline7 t-line-h-22 l-spacing6 font-m"> {{$t('3273')}}</div>
							<div class="divider"></div>
							<div class="pdl-24 pdr-24 pdt-16 pdb-8">
								<div v-for="(checklist,index) in checkedList" :key="index">
								<div class="t-body1  t-line-h-22 l-spacing42 mgt-16 font-r">
								{{++index}}. {{checklist.checkedListAnswer}}
								</div>
								<div class="d-flex pdl-16">
									<div class="mdc-form-field mgr-24 mgt-14 choice">
										<div class="mdc-radio mdc--radio__custom mdc-radio--disabled radio-button-color">
											<input class="mdc-radio__native-control" type="radio" id="radio-1" v-model="checklist.answer" :name="'answer'+index" value="true" :checked="checklist.answer == 'true'" disabled>
											<div class="mdc-radio__background">
												<div class="mdc-radio__outer-circle"></div>
												<div class="mdc-radio__inner-circle"></div>
											</div>
											<div class="mdc-radio__ripple"></div>
										</div>
										<label :for="'answer'+index" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3274')}}</label>
									</div>
									<div class="mdc-form-field mgr-24  mgt-14 choice">
										<div class="mdc-radio mdc--radio__custom mdc-radio--disabled radio-button-color">
											<input class="mdc-radio__native-control" type="radio" id="radio-2" v-model="checklist.answer" :name="'answer'+index" value="false" :checked="checklist.answer == 'false'" disabled>
											<div class="mdc-radio__background">
												<div class="mdc-radio__outer-circle"></div>
												<div class="mdc-radio__inner-circle"></div>
											</div>
											<div class="mdc-radio__ripple"></div>
										</div>
										<label :for="'answer'+index" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3275')}}</label>
									</div>
								</div>
								</div>
							</div>
						</div>

						<div class="mdc-card mgb-28">
							<div class="d-flex align-items-center justify-content-between">
								<div class="pda-24 t-headline7 t-line-h-22 l-spacing6 font-m">{{$t('3276')}}</div>
								<button class="mdc-icon-button content-trigger mgr--16"  tabindex="0"><i
										class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i></button>
							</div>
							<div class="detail-content"  >
								<div class="divider"></div>
							<div class="pdt-8 pdb-8" v-if="changedHistory && changedHistory.length>0">
								<div v-for="(history,index) in changedHistory" :key="index">
								<div class="pdt-8 pdb-8 pdl-24 pdr-24"  v-if="history.memo=='3326'">
									<div class="t-body1  l-spacing48 font-r t-line-h-24">{{$t('3326')}}</div>
									<div class="d-flex align-items-center justify-content-between mgt-4">
										<div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20" v-if="history  && history.modifierInfo.register">{{$moment(history.modifierInfo.register.time).format('L')}} {{$moment(history.modifierInfo.register.time).format('HH:mm')}}</div>
										<!-- <div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20" v-if="details && details.auditor && details.auditor.register">{{$moment(details.auditor.register.time).format('YYYY.MM.DD HH:mm')}}</div> -->
										<div class="t-body3 font-r t-color-bodyGrayA t-line-h-20" v-if="history && history.modifierInfo.register && history.modifierInfo.register.name">{{history && history.modifierInfo.register && history.modifierInfo.register.name? $t('3437',{first: history.modifierInfo.register.name.first, last: history.modifierInfo.register.name.last}):''}}</div>
									</div>
								</div>
								<div class="pdt-8 pdb-8 pdl-24 pdr-24" v-if="history.memo=='3277' && history.memo !='3267'">
									<div class="t-body1  l-spacing48 font-r t-line-h-24">{{$t('3277')}}</div>
									<div class="d-flex align-items-center justify-content-between mgt-4">
										<div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('L')}} {{$moment(history.modifierInfo.modifier.time).format('HH:mm')}}</div>
										<!-- <div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('YYYY.MM.DD HH:mm')}}</div> -->
										<div class="t-body3 font-r t-color-bodyGrayA t-line-h-20">{{history && history.modifierInfo.modifier && history.modifierInfo.modifier.name? $t('3437',{first: history.modifierInfo.modifier.name.first, last: history.modifierInfo.modifier.name.last}):''}}</div>
									</div>
								</div>
								<div class="pdt-8 pdb-8 pdl-24 pdr-24" v-if="history.memo=='3278' && history.memo !='3267'">
									<div class="t-body1  l-spacing48 font-r t-line-h-24">{{$t('3278')}}</div>
									<div class="d-flex align-items-center justify-content-between mgt-4">
										<div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('L')}} {{$moment(history.modifierInfo.modifier.time).format('HH:mm')}}</div>
										<!-- <div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('YYYY.MM.DD HH:mm')}}</div> -->
										<div class="t-body3 font-r t-color-bodyGrayA t-line-h-20">{{history && history.modifierInfo.modifier && history.modifierInfo.modifier.name? $t('3437',{first: history.modifierInfo.modifier.name.first, last: history.modifierInfo.modifier.name.last}):''}}</div>
									</div>
								</div>
								<div class="pdt-8 pdb-8 pdl-24 pdr-24" v-if="history.memo=='3267'">
									<div class="t-body1  l-spacing48 font-r t-line-h-24">{{$t('3267')}}</div>
									<div class="d-flex align-items-center justify-content-between mgt-4">
										<div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('L')}} {{$moment(history.modifierInfo.modifier.time).format('HH:mm')}}</div>
										<!-- <div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20">{{$moment(history.modifierInfo.modifier.time).format('YYYY.MM.DD HH:mm')}}</div> -->
										<div class="t-body3 font-r t-color-bodyGrayA t-line-h-20">{{history && history.modifierInfo.modifier && history.modifierInfo.modifier.name? $t('3437',{first: history.modifierInfo.modifier.name.first, last: history.modifierInfo.modifier.name.last}):''}}</div>
									</div>
								</div>
								</div>
							   </div>
									<div class="pdt-8 pdb-8 pdl-24 pdr-24" v-else>
									<div class="t-body1  l-spacing48 font-r t-line-h-24">{{$t('3326')}}</div>
									<div class="d-flex align-items-center justify-content-between mgt-4">
										<div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20" v-if="details && details.auditor">{{$moment(details.auditor.register.time).format('YYYY.MM.DD HH:mm')}}</div>
										<!-- <div class="t-body3 font-r flex-grow-1 t-color-bodyGrayA t-line-h-20" v-if="details && details.auditor">{{$moment(details.auditor.register.time).format('YYYY.MM.DD HH:mm')}}</div> -->
										<div class="t-body3 font-r t-color-bodyGrayA t-line-h-20" v-if="details && details.auditor">{{details && details.auditor.register && details.auditor.register.name? $t('3437',{first: details.auditor.register.name.first, last: details.auditor.register.name.last}):''}}</div>
									</div>
								</div>
							</div>
						</div>
						
					
				</div>
			</div>
		</main>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {MDCMenu} from '@material/menu';
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";
import storeApi from '@/api/storeMgtApi.js'
import NoData from '../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'


export default {
	components: {
		NoData,
		InfiniteLoading
	},

	data() {
		return {
			details: null,
			checkedList:[],
			changedHistory:[],
			picked:'',
			tabBar: null,
			showQuntity:[],
			showExpiry:[],
			showImage:[],
		}
	},

	
	mounted() {
		if (document.querySelectorAll(".content-trigger")) {
        var contentTrigger = Array.from(document.querySelectorAll(".content-trigger"));
        contentTrigger.forEach((item) => {
            item.addEventListener("click", function () {
            if ((this.firstChild.innerHTML) === 'keyboard_arrow_down') {
                this.firstChild.innerHTML = 'keyboard_arrow_up'
            } else {
                this.firstChild.innerHTML = 'keyboard_arrow_down'
            }
            this.parentNode.nextElementSibling.classList.toggle("d-none")
            });
        })
        }
		//  window.mdc.autoInit();
		this.$showLoading();
		if (document.querySelector('.mdc-tab-bar')) {
			this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'));
		}
		if(document.querySelectorAll('.toggle-menu')){
			const menuEls = Array.from(document.querySelectorAll('.toggle-menu'));

			menuEls.forEach((menuEl) => {
				// Initialize MDCSimpleMenu on each ".mdc-simple-menu"
				const menu = new MDCMenu(menuEl);
				// We wrapped menu and toggle into containers for easier selecting the toggles
				const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
				dropdownToggle.addEventListener('click', () => {
					menu.open = !menu.open;
				});
			});
		}

		let params = {
			goodsId: this.$route.params.goodsId
		}

		// get exam view information
		storeApi.storeView(params).then((response) => {
			this.details = response.data.data
			let checkedListAnswer= this.details?this.details.checkedList:''
			if(checkedListAnswer){
				for (let checkedListAns in checkedListAnswer) {
					for (let checkListQues of this.details.goods.checkList) {
						//console.log('checkedListAns',checkedListAnswer[checkedListAns])
						if (checkedListAnswer[checkedListAns].ordinal === checkListQues.ordinal) {
							Object.assign(checkedListAnswer[checkedListAns], {checkedListAnswer: checkListQues.checklistItem})
						}
					}
				}
			}
			
			this.checkedList=checkedListAnswer
			this.$hideLoading();
		}).catch((err) => {
			console.log(err);
		});

		storeApi.storeViewHistoryChange(params).then((response) => {
			this.changedHistory = response.data.data.content
			//console.log('changedHistory',this.changedHistory)
			this.$hideLoading();
		}).catch((err) => {
			this.$hideLoading();
			console.log(err);
		});
		this.$hideLoading();
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		
		moveBack(){
			this.$router.push({
				name: 'StoreManagement',
			})
		},

		modifyStore() {
			this.$router.push({
				name: 'StoreModify',
				params:this.$route.params
			})
		},
		deleteProduct(){
			let id = this.$route.params.goodsId
			this.$confirm({
				title: this.$t("3281"),
				content: this.$t("3282"),
				cancel: this.$t("3283"),
				accept: this.$t("3284"),
				
			}).then((id) => {
				storeApi.deleteProduct(this.$route.params.goodsId).then((response) => {
					this.$router.push({
						name: 'StoreManagement',
					})
				}).catch(()=>{

				})
			}).catch(() => {
				//this.$router.push("/login");
			});

		},
		
		  autoCloseToggle1(evt) {
			let closeSubmenu = evt.target.parentNode.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none');
			if(closeSubmenu) {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_up'
			} else {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_down'
			}

		},
		 autoCloseToggle2(evt) {
			let closeSubmenu = evt.target.parentNode.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none');
			if(closeSubmenu) {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_up'
			} else {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_down'
			}
			
		 },
		 autoCloseToggle3(evt) {
			let closeSubmenu = evt.target.parentNode.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none');
			if(closeSubmenu) {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_up'
			} else {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_down'
			}
		 },

		 autoCloseToggle4(evt) {
			// console.log( evt.target.parentNode.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none'))
			let closeSubmenu = evt.target.parentNode.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none');
			if(closeSubmenu) {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_up'
			} else {
				evt.target.parentNode.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_down'
			}
		 }

	}
}
</script>